import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class UserBannedChatMessage extends AbstractChatMessage {
  type = MessageTypes.USER_BAN
  body: {
    reason: string
  }

  constructor(data: LX.UserBannedChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.UserBannedChatMessage) {
    return new UserBannedChatMessage(data)
  }

  getShortMessage() {
    return 'User was banned'
  }
}
